/**
 * Detect cross-site iframe embeds so we can log who is framing GatesNow.
 * Cross-origin parents cannot be read via parent.location; use ancestorOrigins / referrer.
 */
export const getEmbedContext = () => {
	if (typeof window === 'undefined') {
		return { inIframe: false, parentOrigin: null, referrer: null };
	}

	let inIframe = false;
	try {
		inIframe = window.self !== window.top;
	} catch {
		inIframe = true;
	}

	let parentOrigin = null;
	try {
		const ancestors = window.location.ancestorOrigins;
		if (ancestors && ancestors.length > 0) {
			parentOrigin = ancestors[ancestors.length - 1] || ancestors[0] || null;
		}
	} catch {
		// ignore
	}

	const referrer = typeof document !== 'undefined' && document.referrer
		? document.referrer
		: null;

	if (!parentOrigin && referrer) {
		try {
			parentOrigin = new URL(referrer).origin;
		} catch {
			// ignore
		}
	}

	return { inIframe, parentOrigin, referrer };
};
